/* HoyoStar purchase accents: decorative only; native purchase handlers stay intact. */
(() => {
  'use strict';

  if (window.__hhsPurchaseDecorator) return;
  window.__hhsPurchaseDecorator = true;

  const selector = [
    'button.button[type="submit"][name="add"]',
    'form[is="product-form"] button.button[type="submit"][data-variant-id]',
    'button.button[data-product-bundle-submit]',
    'button.button[type="submit"][name="checkout"]',
    '.quick-add button.button[aria-controls^="Quickview-"]'
  ].join(',');
  const svgNamespace = 'http://www.w3.org/2000/svg';
  const ownedSelector = '.hhs-purchase-ring, .hhs-purchase-sparkles, .hhs-purchase-card-ring';
  const decorations = new WeakMap();

  function createCardRing() {
    const svg = document.createElementNS(svgNamespace, 'svg');
    svg.setAttribute('class', 'hhs-purchase-card-ring');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const outline = document.createElementNS(svgNamespace, 'rect');
    outline.setAttribute('class', 'hhs-purchase-card-outline');
    outline.setAttribute('pathLength', '100');
    svg.append(outline);
    return svg;
  }

  function createSparkles() {
    const svg = document.createElementNS(svgNamespace, 'svg');
    svg.setAttribute('class', 'hhs-purchase-sparkles');
    svg.setAttribute('viewBox', '0 0 32 32');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('fill', 'currentColor');

    [
      'M13 10C14.25 16.75 15.25 17.75 22 19C15.25 20.25 14.25 21.25 13 28C11.75 21.25 10.75 20.25 4 19C10.75 17.75 11.75 16.75 13 10Z',
      'M25 4.5C25.65 7.85 26.15 8.35 29.5 9C26.15 9.65 25.65 10.15 25 13.5C24.35 10.15 23.85 9.65 20.5 9C23.85 8.35 24.35 7.85 25 4.5Z',
      'M7 3C7.45 5.2 7.8 5.55 10 6C7.8 6.45 7.45 6.8 7 9C6.55 6.8 6.2 6.45 4 6C6.2 5.55 6.55 5.2 7 3Z'
    ].forEach((shape) => {
      const path = document.createElementNS(svgNamespace, 'path');
      path.setAttribute('class', 'hhs-purchase-star');
      path.setAttribute('d', shape);
      svg.append(path);
    });

    return svg;
  }

  function decorate(button) {
    if (!button.isConnected || button.classList.contains('button--close')) return;
    const previous = decorations.get(button);
    if (previous && previous.parent === button.parentElement && previous.ring.parentElement === button &&
        previous.sparkles.parentElement === previous.text && button.contains(previous.text) &&
        button.classList.contains('hhs-purchase-added') &&
        button.classList.contains('hhs-purchase-card') === previous.card &&
        (!previous.cardRing || previous.cardRing.parentElement === previous.ring)) return;

    const text = button.querySelector('.btn-text');
    if (!text || text.closest('button') !== button) return;

    if (!button.querySelector(':scope > .hhs-purchase-ring')) {
      const ring = document.createElement('span');
      ring.className = 'hhs-purchase-ring';
      ring.setAttribute('aria-hidden', 'true');
      button.append(ring);
    }

    // Include compact card variants without styling nested quick-view purchase forms.
    if (button.closest('.quick-add') ||
        (button.matches('.button--small') && button.closest('.product-card, .horizontal-product') && !button.closest('product-info'))) {
      button.classList.add('hhs-purchase-card');
      const ring = button.querySelector(':scope > .hhs-purchase-ring');
      if (!ring.querySelector('.hhs-purchase-card-ring')) ring.append(createCardRing());
    }

    // An SVG preserves the theme's first `.btn-text > span` label lookup.
    // Some native variant updates replace all text children; restore only our SVG.
    if (!text.querySelector(':scope > svg.hhs-purchase-sparkles')) {
      text.prepend(createSparkles());
    }
    if (!button.classList.contains('hhs-purchase-added')) button.classList.add('hhs-purchase-added');
    decorations.set(button, {
      text,
      parent: button.parentElement,
      card: button.classList.contains('hhs-purchase-card'),
      cardRing: button.querySelector('.hhs-purchase-card-ring'),
      ring: button.querySelector(':scope > .hhs-purchase-ring'),
      sparkles: text.querySelector(':scope > svg.hhs-purchase-sparkles')
    });
  }

  function collect(root, buttons) {
    if (!(root instanceof Element) || !root.isConnected) return;
    if (root.matches(selector)) buttons.add(root);
    if (root.childElementCount) root.querySelectorAll(selector).forEach((button) => buttons.add(button));
  }

  function initialize() {
    const initial = new Set();
    collect(document.body, initial);
    initial.forEach(decorate);

    const roots = new Set();
    const changedButtons = new Set();
    let scheduled = false;

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        // Ignore our own insertions; native text resets/removals still need repair.
        if (!record.removedNodes.length && record.addedNodes.length &&
            Array.from(record.addedNodes).every((node) => node instanceof Element && node.matches(ownedSelector))) return;

        const target = record.target instanceof Element ? record.target : record.target.parentElement;
        const button = target?.closest(selector);
        if (button) {
          changedButtons.add(button);
          return;
        }
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) roots.add(node);
        });
      });

      if (scheduled || (!roots.size && !changedButtons.size)) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        const buttons = new Set(changedButtons);
        changedButtons.clear();
        roots.forEach((root) => {
          let parent = root.parentElement;
          while (parent && !roots.has(parent)) parent = parent.parentElement;
          if (!parent) collect(root, buttons);
        });
        roots.clear();
        buttons.forEach(decorate);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
  else {
    initialize();
  }
})();

